<template>
  <a-tag @click="statusClick"
    :color="getStatusColor(status)"
  ><a-icon type="info-circle" style="color: red" v-if="showIcon" />
    {{getStatusName(status)}}
  </a-tag>
</template>

<script>
  export default {
    name: 'StatusTag',
    props:{
      status:{
        type:String,
        default:'1',
      },
      showIcon:{
        type:Boolean,
        default: false,
      }
    },
    methods:{
      getStatusName(status){
        let result='筛选期'
        if(status==='1'){
          result='筛选期'
        }
        else if(status==='2'){
          result='随访期'
        }
        else if(status==='3'){
          result='终止筛选'
        }
        else if(status==='4'){
          result='终止随访'
        }
        else if(status==='5'){
          result='随访完成'
        }
        return result
      },
      getStatusColor(status){
        let result='orange'
        if(status==='1'){
          result='orange'
        }
        else if(status==='2'){
          result='green'
        }
        else if(status==='3'){
          result='pink'
        }
        else if(status==='4'){
          result='red'
        }
        else if(status==='5'){
          result='blue'
        }
        return result
      },
      statusClick(){
        this.$emit('statusClick')
      },
    }
  }
</script>

<style scoped>

</style>